import React from "react";
import { BrowserRouter } from "react-router-dom";

import { getStore } from "shared/redux/addToGlobalStore";

import setupStore from "./Store/setup";
import Page from "./Page";
import PageErrorCatcher from "routers/shared/components/PageErrorCatcher";
import Providers from "routers/shared/components/Providers";

const Desktop = () => {
	setupStore();

	return (
		<Providers store={getStore()}>
			<BrowserRouter>
				<PageErrorCatcher>
					<Page />
				</PageErrorCatcher>
			</BrowserRouter>
		</Providers>
	);
};

export default Desktop;



// WEBPACK FOOTER //
// ./src/routers/Desktop/index.jsx